import React from 'react';
import { parseNumber } from '../utils/calculations';
import { sumaRows } from '../utils/reparto';

export function TipoAsociadoChip({ tipo }) {
  const socio = tipo === 'socio';
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium ${
        socio ? 'bg-azul-surelia/10 text-azul-surelia' : 'bg-cian-digital/15 text-cyan-800'
      }`}
    >
      {socio ? 'Socio' : 'Asociado'}
    </span>
  );
}

const inputCls =
  'w-full rounded-lg border border-azul-surelia/30 px-3 py-1.5 pr-7 text-sm text-right tabular-nums ' +
  'focus:outline-none focus:ring-2 focus:ring-azul-surelia/40 focus:border-azul-surelia disabled:bg-zinc-50';

const fmtMXN = (n) =>
  new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number(n) || 0);

/**
 * The reparto table: one prefilled row per asociado, pct editable, sum at the
 * foot. `rows` come from utils/reparto rowsParaEditor; `onChange(rows)`.
 * `base` (optional) previews the cut of a comisión in pesos per row.
 */
export function RepartoEditor({ rows, onChange, disabled = false, base = null }) {
  const suma = sumaRows(rows);
  const cuadra = suma === 0 || Math.abs(suma - 100) <= 0.01;

  const setPct = (i, v) => {
    const next = rows.map((r, j) => (j === i ? { ...r, pct: v } : r));
    onChange(next);
  };

  return (
    <div className="rounded-xl border border-gray-200 bg-white overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-xs text-gray-500 border-b border-gray-200">
            <th className="py-2 px-3">Nombre</th>
            <th className="py-2 px-3">Tipo</th>
            {base != null && <th className="py-2 px-3 text-right">Monto</th>}
            <th className="py-2 px-3 text-right w-28">%</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr>
              <td colSpan={base != null ? 4 : 3} className="py-4 px-3 text-center text-gray-400">
                Sin asociados en Configuración
              </td>
            </tr>
          )}
          {rows.map((r, i) => {
            const pct = parseNumber(r.pct);
            return (
              <tr key={r.asociadoId} className={`border-b border-gray-100 last:border-0 ${r.activo === false ? 'opacity-60' : ''}`}>
                <td className="py-2 px-3 text-gray-800">
                  {r.nombre}
                  {r.activo === false && <span className="ml-1 text-xs text-gray-400">(inactivo)</span>}
                </td>
                <td className="py-2 px-3"><TipoAsociadoChip tipo={r.tipo} /></td>
                {base != null && (
                  <td className="py-2 px-3 text-right tabular-nums text-gray-600">
                    {pct ? fmtMXN((base * pct) / 100) : '—'}
                  </td>
                )}
                <td className="py-2 px-3">
                  <div className="relative">
                    <input
                      type="text"
                      inputMode="numeric"
                      value={r.pct}
                      disabled={disabled}
                      placeholder="0"
                      onFocus={(e) => e.target.select()}
                      onChange={(e) => setPct(i, e.target.value)}
                      className={inputCls}
                    />
                    <span className="absolute right-2.5 top-1/2 -translate-y-1/2 text-xs text-zinc-400 pointer-events-none">%</span>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
        {rows.length > 0 && (
          <tfoot>
            <tr className="border-t border-gray-200">
              <td colSpan={base != null ? 3 : 2} className="py-2 px-3 text-xs font-medium text-gray-500">Total</td>
              <td className={`py-2 px-3 pr-9 text-right text-sm font-semibold tabular-nums ${cuadra ? 'text-gray-800' : 'text-red-600'}`}>
                {suma}%
              </td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}

export default RepartoEditor;
